import { drawingConstant } from "../../store/actionTypes";

const initState = {
  isNightlyAlert: false, // it  is used to show loading state

  leafletLayer: [], // {id: null, layer: null} // It has all the layer objects drawn from drawing component with their DB geofenceId in id object

  currentDrawingLayer: null, // any drawing layer that is drawn via drawing component is saved in this object until nightly alert form is not submitted
  deleteCurrentDrawingLayer: false, // if we close the popup without filling it the current drawing layer will be removed

  polyData: [], // geofence data from API saved here
  polyCoordinates: [], // geofence coordinates array from API saved here

  coordinates: [], // coordinates of drawn shape saved here
  // create new polygon from drawing component values will be saved here
  newPolyIndex: null,
  newPolygon: false,
  newPolyData: [],
  // edit a geofence logic applies here
  editDrawing: false, // this is a check that specifies to start editing the geofence data
  editPolygon: false,
  editPolyData: [],
  editPolygonIndex: null,
  updatePolygonIndex: null,
  // delete a geofence logic applies here
  deletePolygonIndex: null,
  deletePolygon: false,
  // refresh a geofence logic applies here
  refreshPolyData: false,
  refreshPolyIndex: null,
  // open close nightly alert popup button
  openPopup: false,
  closePopup: false,

  drawEnd: false, // drawEnd is used to specify when to open a modal and when not
};
let leafletLayer;
let newLeafletLayer;
const mapReducer = (state = initState, action) => {
  switch (action.type) {
    //RETRIEVE MY GEOFENCE FROM API
    case drawingConstant.LOAD_POLYGON_REQUEST:
      return state;
    case drawingConstant.LOAD_POLYGON_SUCCESS:
      return {
        ...state,
        polyData: action.response.resp,
        polyCoordinates: action.response.coords,
      };
    case drawingConstant.LOAD_POLYGON_FAILURE:
      return state;
    //MAP FILTER META DATA
    case drawingConstant.CREATE_SHAPE_REQUEST:
      return {
        ...state,
        newPolygon: false,
        isNightlyAlert: true,
        newPolyData: [],
        currentDrawingLayer: null,
      };
    //DRAW END
    case drawingConstant.DELETE_DRAWING_LAYER:
      return {
        ...state,
        currentDrawingLayer: null,
        deleteCurrentDrawingLayer: false,
      }
    case drawingConstant.DRAWING_REQUEST:
      return {
        ...state,
        coordinates: action?.resp?.coordinates,
        editPolygon: false,
        openPopup: true,
        drawEnd: true,
        currentDrawingLayer: action?.resp?.layer,
        deleteCurrentDrawingLayer: false,
      };
    case drawingConstant.DRAWING_DEFAULT:
      return {
        ...state,
        drawEnd: false,
        openPopup: false,
        editPolygon: false,
      };
    case drawingConstant.SAVE_DRAWING_LAYER:
      leafletLayer = state.leafletLayer;
      newLeafletLayer = {};
      newLeafletLayer.id = action.param.param.id;
      newLeafletLayer.layer = action.param.layer;
      return {
        ...state,
        leafletLayer: [...leafletLayer, newLeafletLayer],
        editDrawing: null,
      };
    case drawingConstant.DRAWING_SET_PREFERENCE:
      return {
        ...state,
        openPopup: true,
        drawEnd: true,
        coordinates: action.param.points,
        editPolygon: true,
        editPolyData: action.param,
        editPolygonIndex: action.param.id,
      };
    case drawingConstant.DRAWING_UPDATE_PREFERENCE:
      leafletLayer = state.leafletLayer;
      newLeafletLayer = {};
      newLeafletLayer.id = action.param.param.id;
      newLeafletLayer.layer = action.param.layer;
      return {
        ...state,
        openPopup: true,
        drawEnd: true,
        coordinates: action.param.param.points,
        editPolygon: true,
        editDrawing: false,
        editPolyData: action.param.param,
        editPolygonIndex: action.param.param.id,
        leafletLayer: [...leafletLayer, newLeafletLayer],
      };
    case drawingConstant.DRAWING_CHANGE_PREFERENCE:
      return {
        ...state,
        openPopup: true,
        drawEnd: true,
        editPolygon: true,
      };
    case drawingConstant.DRAW_END_DEFAULT:
      return {
        ...state,
        drawEnd: false,
      };

    //CLOSE MODAL POPUP
    case drawingConstant.CLOSE_POPUP_REQUEST:
      let checkLayer = state.currentDrawingLayer !== null ? true : false;
      return {
        ...state,
        closePopup: true,
        refreshPolyData: false,
        refreshPolyIndex: null,
        deleteCurrentDrawingLayer: checkLayer,
      };
    case drawingConstant.CLOSE_POPUP_DEFAULT:
      return {
        ...state,
        closePopup: false,
        refreshPolyData: false,
        refreshPolyIndex: null,
      };

    //OPEN MODAL POPUP
    case drawingConstant.OPEN_POPUP_DEFAULT:
      return {
        ...state,
        openPopup: false,
      };
    case drawingConstant.OPEN_POPUP_REQUEST:
      return {
        ...state,
        openPopup: true,
      };
    // CREATE GEOFENCE
    case drawingConstant.CREATE_SHAPE_SUCCESS:
      return {
        ...state,
        newPolygon: true,
        newPolyData: action.resp.data.data,
        newPolyIndex: action.resp.data.data.id,
        closePopup: false,
        drawEnd: false,
        isNightlyAlert: false,
      };
    case drawingConstant.CREATE_SHAPE_FAILURE:
      return {
        ...state,
        closePopup: false,
        drawEnd: false,
        isNightlyAlert: false,
      };
      // UPDATE GEOFENCE
    case drawingConstant.UPDATE_SHAPE_REQUEST:
      return {
        ...state,
        refreshPolyData: false,
        refreshPolyIndex: null,
        editPolygon: true,
        editPolygonIndex: null,
        isNightlyAlert: true,
        currentDrawingLayer: null,
      };
    case drawingConstant.UPDATE_SHAPE_SUCCESS:
      return {
        ...state,
        closePopup: false,
        refreshPolyData: true,
        refreshPolyIndex: action.resp.data.data.id,
        drawEnd: false,
        editDrawing: action.resp.data.data.id,
        editPolygon: false,
        editPolygonIndex: action.resp.data.data.id,
        updatePolygonIndex: action.resp.data.data.id,
        editPolyData: action.resp.data.data,
        isNightlyAlert: false,
      };
    case drawingConstant.UPDATE_SHAPE_FAILURE:
      return {
        ...state,
        closePopup: false,
        drawEnd: false,
        editPolygonIndex: null,
        editPolygon: false,
        editPolyData: [],
        isNightlyAlert: false,
      };
      // DELETE GEOFENCE
    case drawingConstant.DELETE_SHAPE_REQUEST:
      return {
        ...state,
        deletePolygon: false,
        deletePolygonIndex: action.index,
        currentDrawingLayer: null,
      };
    case drawingConstant.DELETE_SHAPE_SUCCESS:
      return {
        ...state,
        deletePolygon: true,
        deletePolygonIndex: action.index,
      };
    case drawingConstant.DELETE_SHAPE_FAILURE:
      return {
        ...state,
        deletePolygon: false,
        deletePolygonIndex: action.index,
      };
    default:
      return state;
  }
};
export default mapReducer;
